export default {
  shape:
    '<path fill="#E44656" d="m6.4 18.3-.7-.7 5.6-5.6-5.6-5.6.7-.7 5.6 5.6 5.6-5.6.7.7-5.6 5.6 5.6 5.6-.7.7-5.6-5.6-5.6 5.6Z"/>',
  viewBox: [0, 0, 24, 24],
};
